/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Not_FoundInputs */

const en_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Not Found!`)
};

const ar_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المشروع غير موجود!`)
};

const bn_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রজেক্ট মেলেনি!`)
};

const de_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt nicht gefunden!`)
};

const es_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Proyecto no encontrado!`)
};

const fr_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet introuvable !`)
};

const pt_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto não encontrado!`)
};

const zh_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目未找到！`)
};

const tr_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proje Bulunamadı!`)
};

const ru_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект не найден!`)
};

const pl_work_not_found = /** @type {(inputs: Work_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono projektu!`)
};

/**
* | output |
* | --- |
* | "Project Not Found!" |
*
* @param {Work_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const work_not_found = /** @type {((inputs?: Work_Not_FoundInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Not_FoundInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_work_not_found(inputs)
	if (locale === "bn") return bn_work_not_found(inputs)
	if (locale === "de") return de_work_not_found(inputs)
	if (locale === "es") return es_work_not_found(inputs)
	if (locale === "fr") return fr_work_not_found(inputs)
	if (locale === "pt") return pt_work_not_found(inputs)
	if (locale === "zh") return zh_work_not_found(inputs)
	if (locale === "tr") return tr_work_not_found(inputs)
	if (locale === "ru") return ru_work_not_found(inputs)
	if (locale === "pl") return pl_work_not_found(inputs)
	return en_work_not_found(inputs)
});